import {RECEIVE_NON_REV_AND_REV_FACILITIES_DATA, ERROR_RETRIEVING_NON_REV_AND_REV_FACILITIES_DATA} from "../actions/nonRevAndRevFacilitiesActions"

const initialState = [];

export default function nonRevAndRevFacilitiesReducer (state = initialState, action) {
    switch (action.type) {
        case RECEIVE_NON_REV_AND_REV_FACILITIES_DATA:
            return {
                ...state,
                nonRevAndRevFacilities: action.payload
            };
        case ERROR_RETRIEVING_NON_REV_AND_REV_FACILITIES_DATA:
            return {
                ...initialState,
                error: action.payload
            };
        default:
            return state
    }
};



// WEBPACK FOOTER //
// ./src/reducers/nonRevAndRevFacilitiesReducer.js